import { IntegratorsLabel, Shop } from "@/types/v2";
import { STATUS_OPTIONS } from "@/lib/const";
import { CheckboxInput } from "@/components/Base/CheckboxInput";
import { shop as shopRepository } from "@/repositories/shop";
import { showErrorToast, showSuccessToast } from "@/lib/toast";
import { useMemo } from "react";

type SyncSettingsProps = {
  shopData: Shop;
  syncWithSource: (force?: boolean, fullReSync?: boolean) => void;
};
export const SyncSettings = ({
  shopData,
  syncWithSource,
}: SyncSettingsProps) => {
  const shopId = useMemo(() => shopData.id, [shopData]);
  const integration = useMemo(() => shopData.integration, [shopData]);

  const handleStatusClick = (statusId: string) => {
    if (!shopData || !shopId) return;
    let statusesToCollect = shopData.statusesToSync;
    if (statusesToCollect.includes(statusId)) {
      statusesToCollect = statusesToCollect.filter((s) => s !== statusId);
    } else {
      statusesToCollect.push(statusId);
    }
    shopRepository
      .setStatuses(shopId, statusesToCollect)
      .then(() => {
        showSuccessToast(
          "Statuses Updated",
          "The statuses to sync have been updated. Return to the dashboard to view. Note that it may take time for the updated sync process to complete."
        );
        syncWithSource();
      })
      /* eslint-disable @typescript-eslint/no-explicit-any */
      .catch((err: any) => {
        console.error("An error occurred updating statuses to fetch: ", err);

        showErrorToast(
          "Status Update Failed",
          `An error occurred updating statuses to fetch: ${err}`
        );
      });
  };

  return (
    <div className="flex max-w-96 flex-col gap-4">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Statuses to Import</h2>
          <p className="text-sm text-muted-foreground">
            Select the statuses that you want to have synced to Shop Hero from{" "}
            {integration ? IntegratorsLabel[integration] : "UNKNOWN"}.
          </p>
        </div>
      </div>
      {STATUS_OPTIONS[
        (shopData.integration as "shopware" | "tekmetric") ?? "tekmetric"
      ]?.map((status, index) => (
        <div key={`${status.value}-${status.label}-${index}`}>
          <CheckboxInput
            value={status.value}
            aria-label={status.label}
            label={status.label}
            checked={shopData?.statusesToSync.includes(`${status.value}`)}
            onClick={() => handleStatusClick(`${status.value}`)}
          />
        </div>
      ))}
    </div>
  );
};
